import { StaticImage } from '@/common/constants/displateRoutes';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';

export interface LuminoPageParams {
  externalId: string;
}

interface LuminoPageOptions extends LuminoPageParams, RouteOptions {}

/**
 * @returns '/lumino/123'
 */
export const RouteToLuminoPage = (options: LuminoPageOptions) => {
  return RouteBuilder({ ...options, path: `/lumino/${options.externalId}`, target: 'elysium' });
};

export const LuminoPageConfig: PageConfig = {
  readableName: 'Lumino',
  analyticsGaName: 'lumino',
  analyticsAthenaName: 'lumino',
  pagePathnames: ['/lumino/[externalId]'],
  displayPromoBar: false,
  defaultMeta: {
    title: `Lumino Poster | Displate`,
    description: `Experience the magic of illuminated art with Displate Lumino! A rare OLED Light Poster. Get yours before they're gone!`,
    coverImage: StaticImage('/images/lumino/social/social_lumino.webp'),
  },
};
